module.exports = __webpack_public_path__ + "img/recommendations-breathing-tip.75066cc0.svg";